import React, { useState } from "react";

//UI Material
import {
  Alert,
  CircularProgress,
  Grid,
  Stack,
  SwipeableDrawer,
  TextField,
} from "@mui/material";

//Helpers
import {
  typographyForSubtitles,
  typographyForText,
} from "../../Helpers/typography";
import { fetchWithTokenJSONPost } from "../../Helpers/network";

//MAterial Icons
import { Cancel } from "@mui/icons-material";

//Local components
import ModalWindow from "../Modal";
import ContainedButton from "../basics/ContainedButton";

export default function CancelOrderDrawer({
  open,
  setOpen,
  getData,
  orderNumber,
}) {
  // ==========> Component States <==========
  //State for loading
  const [isLoading, setIsLoading] = useState(false);
  //State for cancel reason
  const [reason, setReason] = useState("");
  //State for open modal
  const [modalOpen, setModalOpen] = useState(false);
  //State for modal text
  const [modalText, setModalText] = useState("");
  //State for modal description
  const [modalDescription, setModalDescription] = useState("");

  // ==========> Component Functions<==========

  // Function to cancel order
  const cancelOrderRequest = async () => {
    setIsLoading(true);
    try {
      const requestResponse = await fetchWithTokenJSONPost("/orders/cancel", {
        orderNumber,
        reason,
      });
      const jsonResponse = await requestResponse.json();
      if (jsonResponse.status === "ok") {
        setModalText("La orden fue cancelada correctamente.");
        setModalDescription(
          `Se ha cancelado correctamente la orden de producción ${orderNumber}.`
        );
      } else {
        setModalText("No se pudo cancelar la orden de producción.");
        setModalDescription(jsonResponse.description);
      }
    } catch (error) {
      setModalText("No se pudo realizar la acción.");
      setModalDescription(
        "Error al cancelar la orden de producción, por favor verifica tu conexión a internet e inténtalo nuevamente."
      );
    }
    setModalOpen(true);
    setIsLoading(false);
    getData();
  };

  // ==========> Component <==========
  return (
    <SwipeableDrawer
      anchor="bottom"
      transitionDuration={600}
      disableSwipeToOpen={true}
      open={open}
      sx={{
        zIndex: "99",
        "& .MuiDrawer-paper": {
          justifyContent: "center",
          borderRadius: "35px 35px 0px 0px",
        },
      }}
      onClose={() => setOpen(false)}
      onOpen={() => {
        /**empty arrow function */
      }}
    >
      <Grid
        container
        justifyContent="center"
        sx={{ padding: "15px" }}
        textAlign="center"
        spacing={1}
      >
        <Grid item xs={12}>
          {typographyForSubtitles("Cancelar Orden", "error")}
        </Grid>
        <Grid item xs={12} sm={10} sx={{ mb: 2 }}>
          <Alert severity="warning">{`Estás a punto de cancelar la orden de producción ${orderNumber}. Una vez cancelada la orden, no se podrá cambiar su estado nuevamente.`}</Alert>
        </Grid>
        <Grid item xs={12} sm={10}>
          <Stack alignItems="center">
            {typographyForText("¿Por qué va a cancelar esta orden?", "bold")}
            <TextField
              value={reason}
              onChange={(e) => {
                setReason(e.target.value);
              }}
              sx={{ width: "100%" }}
            />
          </Stack>
        </Grid>
        <Grid item xs={12} sx={{ mt: 4 }}>
          {isLoading ? (
            <CircularProgress />
          ) : (
            <Stack direction="row" justifyContent="center" spacing={1}>
              <ContainedButton
                text="Salir"
                color="error"
                onClick={() => setOpen(false)}
              />
              <ContainedButton
                text="CANCELAR ORDEN"
                endIcon={<Cancel />}
                variant={reason === "" ? "disabled" : "contained"}
                onClick={() => {
                  cancelOrderRequest();
                }}
              />
            </Stack>
          )}
        </Grid>
      </Grid>
      <ModalWindow
        isOpen={modalOpen}
        handleClose={() => setModalOpen(false)}
        title={modalText}
        text={modalDescription}
        leftText="OK"
        leftClick={() => {
          setModalOpen(false);
          setOpen(false);
        }}
      />
    </SwipeableDrawer>
  );
}
